<template>
  <div>
    <section
      v-if="dateTime.end_time && dateTime.start_time"
      :class="textClass"
      class="inline-block text-gray-500"
    >
      <span v-if="!hideStartDate">
        {{ dayjs(dateTime.start_time).format('MM/DD') }}
      </span>
      <span>
        {{ dayjs(dateTime.start_time).format('HH:mm') }}
      </span>
      <span>-</span>
      <span v-if="!inSameDay(dateTime)" >
        {{ dayjs(dateTime.end_time).format('MM/DD') }}
      </span>
      <span>
        {{ dayjs(dateTime.end_time).format('HH:mm') }}
      </span>
    </section>
    <section v-else-if="dayjs(dateTime).isValid()" :class="textClass" class="inline-block">
      <span v-if="!hideStartDate">
        {{ dayjs(dateTime).format('MM/DD') }}
      </span>
      <span>
        {{ dayjs(dateTime).format('HH:mm') }}
      </span>
    </section>
  </div>
</template>

<script>
import WDateTimeDisplay from './WDateTimeDisplay';

export default WDateTimeDisplay;
</script>
